import TableList from "@components/templates/tablelist";
import {
    HttpMarkUpRateList,
    HttpDeleteMarkUpRate,
    HttpImportMarkUpRate,
    HttpDownloadMarkUpRateTemplate,
} from "@/service/bespeak";
import { mapGetters } from "vuex";

export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpMarkUpRateList,
        handleOperates(params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(
                        this.$t("global.common.choose_one", {
                            defaultValue: "请选择至少一条数据",
                        })
                    );
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "markupRateUpdate",
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "markupRateUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t("global.common.delete", {
                            defaultValue: "删除",
                        }),
                        ajaxRequest: HttpDeleteMarkUpRate,
                        desc: this.$t("fbb.localemanage.confirm_delete", {
                            defaultValue: "删除后不可恢复，是否确认删除？",
                        }),
                        formdata: [
                            {
                                label: this.$t("global.common.notes", {
                                    defaultValue: "备注",
                                }),
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            },
                        ],
                    };
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: this.$t("fbb.alloment.import_data", {
                            defaultValue: "导入数据",
                        }),
                        width: 460,
                        showFooter: false,
                        name: "multipartFile",
                        component: "compUpload",
                        ajaxRequest: HttpImportMarkUpRate,
                        download: () => {
                            this.handleWebfs(
                                HttpDownloadMarkUpRateTemplate,
                                {},
                                "download"
                            );
                        },
                    };
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB +
                            "/api/v2/truckRate/export",
                        this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: "get",
                        }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t("global.common.edit", {
                        defaultValue: "编辑",
                    }),
                    show: true,
                    params: id,
                    operate: "edit",
                },
                {
                    label: this.$t("global.common.delete", {
                        defaultValue: "删除",
                    }),
                    show: true,
                    params: id,
                    operate: "delete",
                },
            ];
        },
    },
    computed: {
        ...mapGetters("dictionary", ["getBillcusorgList"]),
        ToolsData() {
            return [
                {
                    name: this.$t("global.common.add", {
                        defaultValue: "添加",
                    }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导入",
                    operate: "import",
                    theme: "success",
                },
                {
                    name: this.$t("global.common.export", {
                        defaultValue: "导出",
                    }),
                    operate: "export",
                    theme: "primary",
                },
            ];
        },
        SearchsData() {
            return [
                {
                    label: this.$t("global.common.cusorg", {
                        defaultValue: "客户组织",
                    }),
                    key: "EQ_orgId",
                    show: true,
                    tag: "vSelect",
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "EQ_shipType",
                    show: true,
                    tag: "vSelect",
                    options: [
                        { value: 1, label: "LTL" },
                        { value: 2, label: "FTL" },
                    ],
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("", { defaultValue: "状态" }),
                    key: "EQ_status",
                    show: true,
                    tag: "vSelect",
                    options: [
                        { value: 1, label: "启用" },
                        { value: 0, label: "停用" },
                    ],
                    props: {
                        filterable: true,
                    },
                },
            ];
        },
        columns() {
            return [
                {
                    type: "selection",
                    width: 40,
                    align: "center",
                    formName: "id",
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    maxWidth: 90,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t("global.common.cusorg", {
                        defaultValue: "客户组织",
                    }),
                    key: "orgId",
                    render: (h, { row }) => {
                        const arr = this.getBillcusorgList.filter((item) => {
                            return item.value === row.orgId;
                        });
                        return arr[0]?arr[0].label:'--';
                    },
                },
                {
                    title: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "shipType",
                    render: (h, { row }) => {
                        return row.shipType === 1 ? "LTL" : "FTL";
                    },
                },
                {
                    title: this.$t("", {
                        defaultValue: "应收金额加价率",
                    }),
                    key: "receiveAmountRate",
                },
                {
                    title: this.$t("", {
                        defaultValue: "应收保险加价率",
                    }),
                    key: "receiveInsuranceAmountRate",
                    sortable: true,
                },
                {
                    title: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    key: "status",
                    render: (h, { row }) => {
                        return row.status === 1 ? "启用" : "停用";
                    },
                },
                {
                    title: this.$t("global.common.update_time", {
                        defaultValue: "更新时间",
                    }),
                    key: "updatedAt",
                },
            ];
        },
    },
};
